<section class="header">
  <app-menu></app-menu>

  <app-banner></app-banner>
</section>
